var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:Date.now(),staticClass:"qaDrawer"},[_c('mb-drawer',{attrs:{"value":_setup.visible,"size":"middle","title":_setup.data.question},on:{"update:value":function($event){_setup.visible=$event}}},[_c('div',{staticClass:"qaAnswer",domProps:{"innerHTML":_vm._s(_setup.data.answer)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }